export const AddOns = () => {
  return (
    <div className="dp-container col-p-l-0 col-p-r-0">
      <div className="dp-rowflex">
        <div className="col-lg-8 col-md-12 m-b-24">
          <div className="dp-box-shadow">
            <p>Add-ons - Content</p>
          </div>
        </div>
        <div className="col-lg-4 col-sm-12">
          <div className="dp-box-shadow">
            <p>Add-ons - Columna</p>
          </div>
        </div>
      </div>
    </div>
  );
};
